import { Object3D, Euler, Vector3 } from "three";
import { BasePanel } from "./BasePanel.js";
import Util from "../utils/utils.js";

const resetBtnPath = "/assets/vrUI/EditPanel_Scene/reset.png";
const lockBtnPath = "/assets/vrUI/EditPanel_Scene/lock.png";
const unlockBtnPath = "/assets/vrUI/EditPanel_Scene/unlock.png";
const deleteIconPath = "/assets/vrUI/EditPanel_Scene/delete.png";
const copyIconPath = "/assets/vrUI/EditPanel_Scene/copy.png";

const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";

export class EditPanel_Scene extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  init() {}

  async initPanel(parent) {
    this.parent = parent;

    this.uiElements2 = [];

    this.width = 2.175;
    this.height = 0.7;
    this.container = this.uilib.createContainer({
      opacity: 0,
      width: this.width,
      height: this.height,
      radius: 0,
      dragable: false,
    });
    this.parent.add(this.container);
    this.uiElements.push(this.container);
    this.container.visible = this._visible;

    const resetBtnMap = await this.manager.loadManager.loadTexture(
      resetBtnPath
    );
    const lockBtnMap = await this.manager.loadManager.loadTexture(lockBtnPath);
    const unlockBtnMap = await this.manager.loadManager.loadTexture(
      unlockBtnPath
    );
    const deleteIconMap = await this.manager.loadManager.loadTexture(
      deleteIconPath
    );
    const copyIconMap = await this.manager.loadManager.loadTexture(
      copyIconPath
    );

    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);

    this.scaleLockState = true; // 缩放锁定状态

    const texts = ["名称", "位置", "旋转", "缩放"];

    for (var i = 0; i < texts.length; i++) {
      const text = this.uilib.createText({
        text: texts[i],
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
      });
      this.container.add(text);
      text.position.y = this.height / 2 - i * 0.15 - 0.1;
      text.position.x = -this.width / 2 + 0.1;
    }

    let pos = new Vector3(0, 0, 0);
    let rot = new Euler(0, 0, 0);
    let scale = new Vector3(1, 1, 1);
    if (this.manager.sceneManager.currentSelectParent) {
      this.selectModel = this.manager.sceneManager.currentSelectParent;
      pos = this.selectModel.position.clone();
      rot = new Euler().setFromQuaternion(this.selectModel.quaternion.clone());
      scale = this.selectModel.scale.clone();
    }

    // 位置输入框
    {
      this.posInputFileds = [];
      for (var i = 0; i < 3; i++) {
        let str = this.keepDecimal(pos.x);
        if (i === 1) str = this.keepDecimal(pos.y);
        if (i === 2) str = this.keepDecimal(pos.z);
        const posInputFiled = this.uilib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: str,
          textColor: 0xafbbe3,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: "DecimalNumber",
          stateChangeColor: {
            normal: 0x4f5670,
            hover: 0xffffff,
          },
        });
        posInputFiled.addOnValueChangeEvent((text, obj) => {
          this.selectModel = this.manager.sceneManager.currentSelectParent;
          if (!this.selectModel) return;
          if (obj._InputFieldIndex === 0) {
            console.log("修改位置X值" + text, this.selectModel);
            if (this.selectModel) {
              this.selectModel.position.x = text * 1;
            }
          } else if (obj._InputFieldIndex === 1) {
            console.log("修改位置Y值" + text, this.selectModel);
            if (this.selectModel) {
              this.selectModel.position.y = text * 1;
            }
          } else if (obj._InputFieldIndex === 2) {
            // console.log("修改位置Z值" + text);
            if (this.selectModel) {
              this.selectModel.position.z = text * 1;
            }
          }
        });
        this.container.add(posInputFiled);
        posInputFiled.position.z = 0.001;
        posInputFiled._InputFieldIndex = i;
        posInputFiled.position.y = this.height / 2 - 0.25;
        posInputFiled.position.x = -this.width / 2 + i * 0.3 + 0.475;
        this.posInputFileds.push(posInputFiled);
      }

      // 复位按钮
      const btn = this.uilib.createBtn({
        width: 0.1,
        height: 0.1,
        radius: 0,
        color: 0xa8b4db,
        map: resetBtnMap,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
        text: "",
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        this.selectModel = this.manager.sceneManager.currentSelectParent;

        // console.log("位置重置");
        if (this.selectModel) {
          this.selectModel.position.set(0, 0, 0);

          this.posInputFileds[0].changeValue("0");
          this.posInputFileds[1].changeValue("0");
          this.posInputFileds[2].changeValue("0");
        }
      });
      this.container.add(btn);
      btn.position.z = 0.001;
      btn.position.y = this.height / 2 - 0.25;
      btn.position.x = -this.width / 2 + 1.3;

      this.uiElements2 = this.uiElements2.concat(this.posInputFileds);
      this.uiElements2.push(btn);
    }

    // 旋转输入框
    {
      this.rotInputFileds = [];
      for (var i = 0; i < 3; i++) {
        let str = this.keepDecimal(Util.radToDeg(rot.x));
        if (i === 1) str = this.keepDecimal(Util.radToDeg(rot.y));
        if (i === 2) str = this.keepDecimal(Util.radToDeg(rot.z));

        const rotInputFiled = this.uilib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: str,
          textColor: 0xa8b4db,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: "DecimalNumber",
          stateChangeColor: {
            normal: 0x4f5670,
            hover: 0xffffff,
          },
        });
        rotInputFiled.addOnValueChangeEvent((text, obj) => {
          if (obj._InputFieldIndex === 0) {
            // console.log("修改旋转X值" + text);
            this.updateRotate();
          } else if (obj._InputFieldIndex === 1) {
            //console.log("修改旋转Y值" + text);
            this.updateRotate();
          } else if (obj._InputFieldIndex === 2) {
            //console.log("修改旋转Z值" + text);
            this.updateRotate();
          }
        });
        this.container.add(rotInputFiled);
        rotInputFiled.position.z = 0.001;
        rotInputFiled._InputFieldIndex = i;
        rotInputFiled.position.y = this.height / 2 - 0.4;
        rotInputFiled.position.x = -this.width / 2 + i * 0.3 + 0.475;
        this.rotInputFileds.push(rotInputFiled);
      }

      // 复位按钮
      const btn = this.uilib.createBtn({
        width: 0.1,
        height: 0.1,
        radius: 0,
        color: 0xa8b4db,
        map: resetBtnMap,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
        text: "",
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        // console.log("旋转重置");
        this.selectModel = this.manager.sceneManager.currentSelectParent;

        if (this.selectModel) {
          let euler = new Euler();
          this.selectModel.rotation.copy(euler);

          this.rotInputFileds[0].changeValue("0");
          this.rotInputFileds[1].changeValue("0");
          this.rotInputFileds[2].changeValue("0");
        }
      });
      this.container.add(btn);
      btn.position.z = 0.001;
      btn.position.y = this.height / 2 - 0.4;
      btn.position.x = -this.width / 2 + 1.3;

      this.uiElements2 = this.uiElements2.concat(this.rotInputFileds);
      this.uiElements2.push(btn);
    }

    // 缩放输入框
    {
      this.scaleInputFileds = [];
      for (var i = 0; i < 3; i++) {
        let str = this.keepDecimal(scale.x);
        if (i === 1) str = this.keepDecimal(scale.y);
        if (i === 2) str = this.keepDecimal(scale.z);
        const scaleInputFiled = this.uilib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: str,
          textColor: 0xa8b4db,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: "DecimalNumber",
          stateChangeColor: {
            normal: 0x4f5670,
            hover: 0xffffff,
          },
        });
        scaleInputFiled.addOnValueChangeEvent((text, obj) => {
          this.selectModel = this.manager.sceneManager.currentSelectParent;
          if (!this.selectModel) return;
          if (obj._InputFieldIndex === 0) {
            // console.log("修改缩放X值" + text);
            if (this.selectModel) {
              let value = this.keepDecimal(text * 1);
              //if (this.scaleLockState) {
              if(false){  
              this.selectModel.scale.set(value, value, value);

                this.scaleInputFileds[1].changeValue(value);
                this.scaleInputFileds[2].changeValue(value);
              } else this.selectModel.scale.x = value;
            }
          } else if (obj._InputFieldIndex === 1) {
            // console.log("修改缩放Y值" + text);
            if (this.selectModel) {
              let value = this.keepDecimal(text * 1);
              //if (this.scaleLockState) {
              if(false){  
              this.selectModel.scale.set(value, value, value);

                this.scaleInputFileds[0].changeValue(value);
                this.scaleInputFileds[2].changeValue(value);
              } else this.selectModel.scale.y = value;
            }
          } else if (obj._InputFieldIndex === 2) {
            // console.log("修改缩放Z值" + text);
            if (this.selectModel) {
              let value = this.keepDecimal(text * 1);
              //if (this.scaleLockState) {
              if(false){ 
              this.selectModel.scale.set(value, value, value);

                this.scaleInputFileds[0].changeValue(value);
                this.scaleInputFileds[1].changeValue(value);
              } else this.selectModel.scale.z = value;
            }
          }
        });
        this.container.add(scaleInputFiled);
        scaleInputFiled.position.z = 0.001;
        scaleInputFiled._InputFieldIndex = i;
        scaleInputFiled.position.y = this.height / 2 - 0.55;
        scaleInputFiled.position.x = -this.width / 2 + i * 0.3 + 0.475;
        this.scaleInputFileds.push(scaleInputFiled);
      }

      // 复位按钮
      const btn = this.uilib.createBtn({
        width: 0.1,
        height: 0.1,
        radius: 0,
        color: 0xa8b4db,
        map: resetBtnMap,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
        text: "",
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        // console.log("缩放重置");
        this.selectModel = this.manager.sceneManager.currentSelectParent;
        if (this.selectModel) {
          this.selectModel.scale.set(1, 1, 1);

          this.scaleInputFileds[0].changeValue("1");
          this.scaleInputFileds[1].changeValue("1");
          this.scaleInputFileds[2].changeValue("1");
        }
      });
      this.container.add(btn);
      btn.position.z = 0.001;
      btn.position.y = this.height / 2 - 0.55;
      btn.position.x = -this.width / 2 + 1.3;

      // 锁定按钮
      const lockBtn = this.uilib.createBtn({
        width: 0.1,
        height: 0.1,
        radius: 0,
        color: 0xa8b4db,
        map: this.scaleLockState ? lockBtnMap : unlockBtnMap,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
        text: "",
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        this.scaleLockState = !this.scaleLockState;
        obj.material.map = this.scaleLockState ? lockBtnMap : unlockBtnMap;
        obj.material.needsUpdate = true;

        this.selectModel = this.manager.sceneManager.currentSelectParent;
        // 三个轴缩放不一致时取平均值
        if (this.scaleLockState && this.selectModel) {
          let scale = this.selectModel.scale;
          if (
            scale.x !== scale.y ||
            scale.y !== scale.z ||
            scale.x !== scale.z
          ) {
            scale = this.keepDecimal((scale.x + scale.y + scale.z) / 3);
            this.selectModel.scale.set(scale, scale, scale);

            this.scaleInputFileds[0].changeValue(scale);
            this.scaleInputFileds[1].changeValue(scale);
            this.scaleInputFileds[2].changeValue(scale);
          }
        }
      });
      this.container.add(lockBtn);
      lockBtn.position.z = 0.001;
      lockBtn.position.y = this.height / 2 - 0.55;
      lockBtn.position.x = -this.width / 2 + 0.275;

      this.uiElements2 = this.uiElements2.concat(this.scaleInputFileds);
      this.uiElements2.push(btn);
      this.uiElements2.push(lockBtn);
    }

    // 擦除按钮
    {
      const deleteBtn = this.uilib.createBtn({
        map: btn_normal,
        text: "",
        width: 0.3,
        height: 0.08,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      deleteBtn.addHoverEnterEvent((obj) => {});
      deleteBtn.addHoverExitEvent((obj) => {});
      deleteBtn.addClickEvent((obj) => {
        // console.log("擦除模型");

        this.manager.interface.deleteCurrentModel();
        this.hideInfo();
      });
      this.container.add(deleteBtn);
      deleteBtn.position.z = 0.001;
      deleteBtn.position.x = 0.05;
      deleteBtn.position.y = this.height / 2 - 0.1;

      this.uiElements2.push(deleteBtn);

      const icon = this.uilib.createImage({
        renderOrder: 100000,
        map: deleteIconMap,
        width: 0.08,
        height: 0.08,
        radius: 0,
      });
      deleteBtn.add(icon);
      icon.position.x = -0.06;

      const text = this.uilib.createText({
        text: "擦除",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      deleteBtn.add(text);
      text.position.x = 0.035;
    }

    // 竖线
    {
      const line = this.uilib.createContainer({
        width: 0.005,
        height: 0.6,
        color: 0xa8b4db,
        radius: 0,
        opacity: 0.5,
      });
      this.container.add(line);
      line.position.x = 0.3;
      line.position.z = 0.001;
    }

    // 复制相关输入框
    {
      const texts = ["行数", "列数", "间隔"];
      this.copyInputFileds = [];
      for (var i = 0; i < texts.length; i++) {
        const text = this.uilib.createText({
          text: texts[i],
          textColor: 0xafbbe3,
          textSize: 0.04,
          font: "bold",
          align: "left",
        });
        this.container.add(text);
        text.position.y = this.height / 2 - i * 0.15 - 0.1;
        text.position.x = 0.35;

        const inputfield = this.uilib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: "1",
          textColor: 0xa8b4db,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: i === 2 ? "DecimalNumber" : "IntegerNumber",
          stateChangeColor: {
            normal: 0x4f5670,
            hover: 0xffffff,
          },
        });
        inputfield._InputFieldIndex = i;
        this.container.add(inputfield);
        inputfield.position.z = 0.001;
        inputfield.position.y = this.height / 2 - i * 0.15 - 0.1;
        inputfield.position.x = 0.65;
        this.copyInputFileds.push(inputfield);
      }
      this.uiElements2 = this.uiElements2.concat(this.copyInputFileds);
    }

    // 复制按钮
    {
      const copyBtn = this.uilib.createBtn({
        map: btn_normal,
        text: "",
        width: 0.3,
        height: 0.08,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      copyBtn.addHoverEnterEvent((obj) => {});
      copyBtn.addHoverExitEvent((obj) => {});
      copyBtn.addClickEvent((obj) => {
        // console.log("复制模型");
        const row = this.copyInputFileds[0].text * 1;
        const col = this.copyInputFileds[1].text * 1;
        const offset = this.copyInputFileds[2].text * 1;

        this.manager.interface.copyObj(row, col, offset);
        this.vrManager.selectModel();
      });
      this.container.add(copyBtn);
      copyBtn.position.z = 0.001;
      copyBtn.position.x = 0.565;
      copyBtn.position.y = this.height / 2 - 0.55;

      this.uiElements2.push(copyBtn);

      const icon = this.uilib.createImage({
        renderOrder: 100000,
        map: copyIconMap,
        width: 0.08,
        height: 0.08,
        radius: 0,
      });
      copyBtn.add(icon);
      icon.position.x = -0.06;

      const text = this.uilib.createText({
        text: "复制",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      copyBtn.add(text);
      text.position.x = 0.035;
    }

    if (!this._visible) {
      this.closePanel();
    } else if (!this.selectModel) {
      this.hideInfo();
    }
    //this.createNameValueText("现代多层办公楼");

    // if (this.manager.sceneManager.currentSelectParent) {
    //   setTimeout(() => {
    //     this.setSelectModel(this.manager.sceneManager.currentSelectParent);
    //   }, 1000);
    // }
  }

  /**
   * 保留4位小数并转成字符串
   * @param {*} value
   * @returns
   */
  keepDecimal(value) {
    return Math.round(value * 10000) / 10000 + "";
  }

  updateRotate() {
    this.selectModel = this.manager.sceneManager.currentSelectParent;
    if (!this.selectModel) return;
    let euler = new Euler(
      Util.degToRad(parseFloat(this.rotInputFileds[0].text)),
      Util.degToRad(parseFloat(this.rotInputFileds[1].text)),
      Util.degToRad(parseFloat(this.rotInputFileds[2].text))
    );
    this.selectModel.rotation.copy(euler);
  }

  /**
   * 创建模型名字文字
   * @param {*} name
   * @returns
   */
  createNameValueText(name) {
    if (this.currentName && this.currentName === name) {
      return;
    }

    this.clearNameValueText();

    this.currentName = name;

    this.nameValueText = this.uilib.createText({
      text: name,
      textColor: 0xafbbe3,
      textSize: 0.04,
      font: "bold",
      align: "left",
    });
    this.container.add(this.nameValueText);
    this.nameValueText.position.y = this.height / 2 - 0.1;
    this.nameValueText.position.x = -this.width / 2 + 0.35;
  }

  /**
   * 清除模型名字文字
   */
  clearNameValueText() {
    if (this.nameValueText) {
      this.uilib.removeUI(this.nameValueText);
      this.nameValueText = null;
    }
    this.currentName = "";
  }

  /**
   * 设置当前选中的模型，需要先调用SceneManager.attach函数（统一设置一个父对象）后再调用这个函数
   * @param {*} model 传进来的是选中模型的临时父对象（uniformParent）
   */
  setSelectModel(model) {
    if (!model) {
      this.hideInfo();
      return;
    }
    this.selectModel = model;

    this.showInfo();
  }

  /**
   * 选中模型后显示出可编辑信息
   */
  showInfo() {
    this.selectModel = this.manager.sceneManager.currentSelectParent;
    if (!this.selectModel || this.selectModel.children.length <= 0) return;

    // 选中了多个对象
    if (this.selectModel.children.length > 1) {
      this.createNameValueText("多个模型");
    } else {
      this.createNameValueText(this.selectModel.name);
    }

    this.updateUIValue();

    for (var i = 0; i < this.uiElements2.length; i++) {
      if (this.uiElements2[i].setEnabled) {
        this.uiElements2[i].setEnabled(true);
      }
    }
  }

  updateUIValue() {
    this.selectModel = this.manager.sceneManager.currentSelectParent;
    if (!this.selectModel) return;

    this.posInputFileds[0].changeValue(
      this.keepDecimal(this.selectModel.position.x)
    );
    this.posInputFileds[1].changeValue(
      this.keepDecimal(this.selectModel.position.y)
    );
    this.posInputFileds[2].changeValue(
      this.keepDecimal(this.selectModel.position.z)
    );

    this.scaleInputFileds[0].changeValue(
      this.keepDecimal(this.selectModel.scale.x)
    );
    this.scaleInputFileds[1].changeValue(
      this.keepDecimal(this.selectModel.scale.y)
    );
    this.scaleInputFileds[2].changeValue(
      this.keepDecimal(this.selectModel.scale.z)
    );

    let tempRot = new Euler().setFromQuaternion(
      this.selectModel.quaternion.clone()
    );
    this.rotInputFileds[0].changeValue(
      this.keepDecimal(Util.radToDeg(tempRot.x))
    );
    this.rotInputFileds[1].changeValue(
      this.keepDecimal(Util.radToDeg(tempRot.y))
    );
    this.rotInputFileds[2].changeValue(
      this.keepDecimal(Util.radToDeg(tempRot.z))
    );
  }

  /**
   * 没有选中模型时隐藏可编辑信息
   */
  hideInfo() {
    this.posInputFileds[0].changeValue(this.keepDecimal(0));
    this.posInputFileds[1].changeValue(this.keepDecimal(0));
    this.posInputFileds[2].changeValue(this.keepDecimal(0));

    this.scaleInputFileds[0].changeValue(this.keepDecimal(1));
    this.scaleInputFileds[1].changeValue(this.keepDecimal(1));
    this.scaleInputFileds[2].changeValue(this.keepDecimal(1));

    this.rotInputFileds[0].changeValue(this.keepDecimal(0));
    this.rotInputFileds[1].changeValue(this.keepDecimal(0));
    this.rotInputFileds[2].changeValue(this.keepDecimal(0));

    for (var i = 0; i < this.uiElements2.length; i++) {
      if (this.uiElements2[i].setEnabled) {
        this.uiElements2[i].setEnabled(false);
      }
    }

    this.clearNameValueText();
  }

  closePanel() {
    super.closePanel();

    // 取消当前模型选中状态
    this.manager.sceneManager.detach();
    this.manager.vrManager.selectHiarerchyNodes([]);
    this.setSelectModel();

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    if (this.manager.sceneManager.currentSelectParent) {
      this.setSelectModel(this.manager.sceneManager.currentSelectParent);
    }

    this.manager.interface.setClickMode(2); // 切换到场景模型模式
  }
}
